const STEPS = [
  { n: "I", h: "Accept & allocate", p: "Sign the digital Membership Agreement, then settle your allocation in USDT to the GTA X Consolidated Treasury. It is recorded to your member ledger on confirmation." },
  { n: "II", h: "One managed mandate", p: "All allocations are deployed together as a single discretionary XAU/USD mandate, executed A-book with a regulated broker, Monday to Friday." },
  { n: "III", h: "Distributions from realised profit", p: "Only realised net trading profit is distributed, at your tier's profit share. No profit, no distribution. Redeem in USDT on your tier's schedule." },
];

const TRUST = ["A-book execution", "XAU/USD only", "Consolidated Treasury", "On-chain verifiable", "Profit-only distributions", "Digital Membership Agreement", "DFI Holdings", "Abu Dhabi"];

const PHASES = [
  { p: "Phase I · Now", h: "Private circle", d: "Invitation-only. Member allocations are held in the GTA X Consolidated Treasury, a single USDT settlement account whose address is published so every member can verify balances on-chain, supported by periodic member statements." },
  { p: "Phase II · Next", h: "Your own account", d: "Members migrate to individually designated, non-custodial managed accounts in their own name, with the desk trading under a limited power of attorney." },
];

export const GtaxRoadmap = () => (
  <section className="py-28 gx-line" data-testid="gtax-roadmap">
    <div className="gx-wrap">
      <p className="gx-eyebrow">Custody &amp; roadmap</p>
      <h2 className="gx-serif text-4xl md:text-5xl mt-6 max-w-2xl">Verifiable today. Individually segregated tomorrow.</h2>
      <div className="mt-16 grid md:grid-cols-2 gap-6">
        {PHASES.map((x, i) => (
          <div key={x.p} className="gx-card p-10" data-testid={`gtax-phase-${i + 1}`}>
            <div className="gx-eyebrow">{x.p}</div>
            <h3 className="gx-caps text-2xl mt-5">{x.h}</h3>
            <p className="mt-4 text-[color:var(--mute)] leading-relaxed">{x.d}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const GtaxHow = () => (
  <section className="gx-ivory pt-32" data-testid="gtax-how">
    <div className="gx-wrap grid lg:grid-cols-12 gap-16 items-center">
      <div className="lg:col-span-7">
        <p className="gx-eyebrow">The method</p>
        <h2 className="gx-serif text-4xl md:text-5xl mt-6 max-w-xl">One mandate. Rigorous discipline. Profit shared only when realised.</h2>
        <div className="mt-16 space-y-12">
          {STEPS.map((s) => (
            <div key={s.n} className="grid grid-cols-[64px_1fr] gap-6 pb-10 border-b border-[color:var(--line)]" data-testid={`gtax-step-${s.n}`}>
              <div className="gx-serif text-4xl gx-gold">{s.n}</div>
              <div>
                <h3 className="gx-caps text-xl">{s.h}</h3>
                <p className="mt-3 text-[color:var(--mute)] leading-relaxed max-w-md">{s.p}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="lg:col-span-5">
        <img src="/gtax/statue.jpg" alt="The GTA X guardian" className="w-full max-w-md mx-auto mix-blend-multiply" data-testid="gtax-guardian" />
      </div>
    </div>
    <div className="mt-28 py-7 overflow-hidden border-y border-[color:var(--line)]">
      <div className="gx-marquee gx-caps text-lg text-[color:var(--mute)]">
        {[...TRUST, ...TRUST, ...TRUST, ...TRUST].map((t, i) => <span key={i}>{t} <span className="text-[color:var(--gold)] ml-16">✦</span></span>)}
      </div>
    </div>
  </section>
);
